import { FC, ReactNode } from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { Box, IconButton, FormLabel, useTheme, Tooltip } from '@mui/material';

import { useValidationSchema } from '~components/form/app-form/app-form';
import { AppTypography } from '~components/ui/typography/app-typography';
// import { useIsFieldRequired } from '~hooks/use-is-field-required';

type FieldWrapperProps = {
  name?: string;
  label?: ReactNode;
  labelIcon?: ReactNode;
  info?: ReactNode;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  htmlFor?: string;
  disabled?: boolean;
  required?: boolean;
};

export const FieldWrapper: FC<FieldWrapperProps> = ({
  name,
  label,
  info,
  hint,
  error,
  children,
  htmlFor,
  disabled,
  required,
  labelIcon,
}) => {
  const theme = useTheme();

  const { schema, isFieldRequired } = useValidationSchema();

  const isRequired =
    (schema && isFieldRequired(name || '')) || required || false;

  // const isRequired = useIsFieldRequired(name || '');

  // console.log(`${name} isRequired:::`,isRequired);

  return (
    <Box display={'flex'} flexDirection={'column'}>
      {label && (
        <Box display="flex" alignItems="center" mb={0.5} gap={0.5}>
          <FormLabel
            htmlFor={htmlFor}
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: disabled ? 'default' : 'pointer',
              color: theme.palette.fog['25'],
              ...theme.typography['body-md'],
              fontWeight: 600,
              lineHeight: '1.2',
            }}
          >
            {labelIcon}
            {label}
            {isRequired && (
              <Box component="span" ml={0.25} color="red.100" fontSize={14}>
                *
              </Box>
            )}
          </FormLabel>

          {info && (
            <Tooltip
              title={info}
              arrow
              placement="top"
              slotProps={{
                tooltip: {
                  sx: {
                    ...theme.typography['body-md'],
                    backgroundColor: theme.palette.background.paper,
                    color: theme.palette.text.primary,
                    padding: '4px 12px',
                    borderRadius: '8px',
                    border: '1px solid',
                    borderColor: theme.palette.fog['80'],
                    boxShadow: 'none',
                    maxWidth: 220,
                  },
                },
                arrow: {
                  sx: {
                    color: theme.palette.background.paper,
                    '&::before': {
                      backgroundColor: theme.palette.background.paper,
                      border: '1px solid',
                      borderColor: theme.palette.fog['80'],
                      transform: 'rotate(45deg)',
                      width: 10,
                      height: 10,
                      boxSizing: 'border-box',
                    },
                  },
                },
              }}
            >
              <IconButton
                size="small"
                sx={{
                  p: 0,
                  ml: 0.5,
                  color: disabled ? 'text.disabled' : 'text.secondary',
                }}
              >
                <InfoIcon
                  sx={{
                    fontSize: 18,
                    color: theme.palette.primaryTokens['100'],
                  }}
                />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      )}

      {/* Само поле */}
      {children}

      {error && (
        <AppTypography
          size="body-caption"
          color="error"
          display="block"
          mt={0.5}
        >
          {error}
        </AppTypography>
      )}

      {/* Хинт текст под лейблом */}
      {hint && (
        <AppTypography
          size="body-caption"
          // size="body-sm"
          mt={0.5}
          display="block"
          color={theme.palette.fog['25']}
        >
          {hint}
        </AppTypography>
      )}
    </Box>
  );
};
